import { useEffect, useRef } from 'react';
import type { TraitDeCarte, TransversaleDeFeuille } from '../partage/api/types';
import { useEchap } from '../partage/useEchap';
import { CE_LIEN } from '../partage/vocabulaire';
import { GestesDuLien } from '../moteur/conditions';
import type { Point } from './geometrieCarte';
import './SignesDuLien.css';

/** Un lien désigné sur la carte : le trait cliqué, et là où ses signes s'ouvrent. */
export interface LienDesigne {
  lien: TraitDeCarte | TransversaleDeFeuille;
  point: Point;
}

/**
 * **Les signes d'un trait cliqué** (chantier liens-entre-bulles, ticket 03, décisions 4 et 11 du
 * cadrage) : l'œil, ⇄ et la croix, écrits une fois avec la fiche Plan (`GestesDuLien`, ticket 05),
 * dans une petite boîte posée au milieu du trait. Échap, ou un clic ailleurs, la retire ; un geste
 * réussi aussi.
 *
 * Posés au milieu du trait, à leur taille d'écran quel que soit le zoom (`--echelle`).
 */
export function SignesDuLien({ designe, onFermer }: { designe: LienDesigne; onFermer: () => void }) {
  const { lien, point } = designe;
  const boite = useRef<HTMLDivElement>(null);

  useEchap(true, onFermer);

  // Un clic ailleurs les retire ; un clic sur un autre trait en désigne un autre (la carte le fait).
  useEffect(() => {
    const ailleurs = (e: PointerEvent) => {
      const cible = e.target as Element | null;
      if (boite.current?.contains(cible) || cible?.closest?.('.tableau-lien-zone')) return;
      onFermer();
    };
    window.addEventListener('pointerdown', ailleurs, true);
    return () => window.removeEventListener('pointerdown', ailleurs, true);
  }, [onFermer]);

  if (lien.lienId === null) return null;

  return (
    <div
      ref={boite}
      className="signes-du-lien carte-commandes"
      data-lien={lien.lienId}
      style={{ left: point.x, top: point.y }}
      role="group"
      aria-label={CE_LIEN}
    >
      <GestesDuLien lien={lien} onFait={onFermer} />
    </div>
  );
}
